// Hook that automatically geofences an app
import axios from "axios";
import { useEffect, useState } from "react";
export var GeofenceCountry;
(function (GeofenceCountry) {
    GeofenceCountry["SG"] = "SG";
    //SINGAPORE = "SG",
    // US = "US",
})(GeofenceCountry || (GeofenceCountry = {}));
// and then redirects to a URL if not applicable
export var useGeofence = function (country) {
    // If rejected, redirect to rejectedUrl
    var _a = useState(false), rejected = _a[0], setRejected = _a[1];
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    useEffect(function () {
        setLoading(true);
        axios
            .get("https://ipapi.co/country")
            .then(function (_a) {
            var data = _a.data;
            if (data === country) {
                setRejected(true);
            }
            else {
                setRejected(false);
            }
        })
            .catch(function (e) {
            // Geofence failed. Should we default to rejected or ok?
            setRejected(false);
        })
            .finally(function () {
            setLoading(false);
        });
    }, [country]);
    return {
        rejected: rejected,
        loading: loading,
    };
};
//# sourceMappingURL=useGeofence.js.map